import * as React from 'react'
import type { SVGProps } from 'react'
const SvgOnlyfans = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.2367 5C4.2399 5 1 8.2399 1 12.2367s3.2399 7.2366 7.2367 7.2366 7.2366-3.2398 7.2366-7.2366S12.2335 5 8.2367 5m0 9.4077c-1.1992 0-2.171-.9719-2.171-2.171s.9719-2.171 2.171-2.171 2.171.9719 2.171 2.171c.0017 1.1974-.9678 2.1693-2.1652 2.171z"
    />
    <path
      fill="currentColor"
      d="M16.3707 10.4275c1.8386.5292 4.0091 0 4.0091 0-.6298 2.7499-2.6272 4.4723-5.5074 4.6819-1.1414 2.6496-3.7507 4.3656-6.6357 4.3639l2.171-6.9004C12.6395 5.4805 13.7833 5 19.076 5h3.634c-.6079 2.6776-2.7031 4.7229-6.3393 5.4275"
    />
  </svg>
)
export default SvgOnlyfans
